import { UIRouterModule } from "@uirouter/angular";
import { NgModule } from "@angular/core";
import over from "lodash.over";
import {
  BASE_OKR_VIEWS_STATE,
  BASE_OKR_VIEW_STATE,
  createGoalStates,
  createMetricStates,
  goalStates,
  metricStates,
  states as ng1States,
  taskStates,
  updateMetricStates,
} from "@gtmhub/okrs/okrs.states";
import { loadChildFutureStatesConfig, registerChildFutureStateFactories, replaceWithFutureStatesConfig } from "@webapp/core/routing/routing.utils";

const states: unknown[] = [...ng1States];

registerChildFutureStateFactories({ createGoalStates, createMetricStates, goalStates, metricStates, taskStates, updateMetricStates });

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states,
      config: over(
        replaceWithFutureStatesConfig(["gtmhub.goals", "gtmhub.tasks", "gtmhub.sessions", "gtmhub.workflow", BASE_OKR_VIEW_STATE, BASE_OKR_VIEWS_STATE]),
        loadChildFutureStatesConfig
      ),
    }),
  ],
})
export class OkrsRoutingModule {}
